<template>
    <div
        :id="mailModalId"
        class="preview-container"
    >
        <DButton
            color="secondary"
            :label="__('messages.preview_text')"
            @click="handlePreview"
        />
        <PreviewTextModal
            :show-modal="showPreview"
            :is-html="isHtml"
            :content="formattedContent"
            :errors="errors"
            @modalClosed="showPreview=false"
        />
    </div>
</template>

<script>

import PreviewTextModal from './PreviewTextModal'
import NProgress from 'nprogress'

export default {
    name: 'PreviewText',
    components: { PreviewTextModal },
    props: {
        showModal: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            default: null
        },
        isHtml: {
            type: Boolean,
            default: false
        },
        emailType: {
            type: String,
            default: null
        },
        sample: {
            type: String,
            default: null
        }
    },
    data () {
        return {
            showPreview: false,
            formattedContent: null,
            errors: [],
            mailModalId: 'mailModal'
        }
    },
    methods: {
        handlePreview () {
            NProgress.start()
            this.errors = []
            this.formattedContent = null
            window.axios.post(this.$route('tools.emails.preview-text'), {
                content: this.content,
                emailType: this.emailType,
                sample: this.sample
            }).then(response => {
                NProgress.done()
                this.showPreview = true
                this.formattedContent = response.data.content
            }).catch(error => {
                NProgress.done()
                this.showPreview = true
                const errorObject = error.response && error.response.data && error.response.data.errors
                    ? error.response.data.errors
                    : {}
                Object.keys(errorObject).forEach((field) => {
                    errorObject[field].forEach((message) => {
                        this.errors.push(message)
                    })
                })
            }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
    .preview-container {
        display: flex;
        justify-content: flex-end;
    }
</style>
